import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';

import { SharedService } from 'src/app/Shared/shared-service.service';
import { TxSet } from 'src/model/set.model';
import { SetService } from 'src/services/set.service';

@Component({
    selector: 'app-receipt-add-expense-admin-remark',
    templateUrl: './receipt-add-expense-admin-remark.component.html',
    styleUrls: ['./receipt-add-expense-admin-remark.component.scss'],
    standalone: false
})
export class ReceiptAddExpenseAdminRemarkComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  private setService = inject(SetService);

  disabledSubmit = false;
  // remark: string;
  tagName: string;

  @Input() set: TxSet;
  @Input() editMode = false;

  updateSet: TxSet;

  @Output() passEntry = new EventEmitter<TxSet>();

  ngOnInit(): void {
    this.updateSet = Object.assign(new TxSet(), this.set);
    this.tagName = this.updateSet.Tags?.join(', ');
  }

  async submit() {
    let result: TxSet;
    if (this.updateSet.SetRemark?.trim().length > 0) {
      this.updateSet.Tags = this.tagName?.split(',').map(t => t.trim());
      this.updateSet.Saved = this.editMode === true ? this.set.Saved : true;
      if (this.set.SetRemark !== undefined) {
        result = await this.setService.putSetRemark(this.updateSet);
      } else {
        result = await this.setService.postSetRemark(this.updateSet);
      }
      this.passEntry.emit(result);
      this.reset();
    } else {
      this.sharedService.openAlert("Please make sure you key in remark before can bookmark it", ALERT_TYPE.DANGER);
    }
  }

  reset() {
    this.activeModal.close();
  }
}
